import { BASE_URL } from '../../constants/api';
import Fetch from '../fetch';
import Store from '../../stores/Store';

import CacheService from '../../utils/CacheService';

import type {
  FormControlConfig,
  RiskProfileAnswerOptionSelect,
  RiskProfileAnswerOptionType,
  RiskProfileFormControlType,
  RiskProfileQuestionType,
} from '../../types/types';

export async function getRiskProfileQuestions(): Promise<
  RiskProfileFormControlType[]
> {
  const store = new Store();
  const token = store.get('token');

  const url = `${BASE_URL}/api/kycApi/loadRiskProfileQuestionAndAnswer?token=${token}`;

  const json = await CacheService(
    `kycApi/loadRiskProfileQuestionAndAnswer`,
    async () => {
      const json = await Fetch<RiskProfileQuestionType[]>(url, {
        method: 'GET',
        headers: {
          'x-token': store.get('x-token'),
          'x-csrf': store.get('x-csrf'),
          accept: 'application/json',
        },
      });

      const controls: FormControlConfig[] = json.map(control => {
        // control.answerId
        if (control.questionName.includes('MULTI')) {
          const options: RiskProfileAnswerOptionSelect[] =
            control.answerOption.map((item: RiskProfileAnswerOptionType) => {
              //question_id - answer_id - answer_score
              const value = `${control.questionId}_${item.id}_${item.score}`;
              return {
                value,
                display: item.answerText,
                score: item.score,
                questionId: control.questionId,
              };
            });

          return {
            tag:
              control.questionId == '75' ? 'checkbox-riskprofile' : 'checkbox',
            value: control.answerId,
            name: control.questionId,
            label: control.questionText,
            validator: 'required=true',
            options,
          };
        }

        const options = control.answerOption.map(item => {
          const value = `${control.questionId}_${item.id}_${item.score}`;
          return {
            value,
            display: item.answerText,
            score: item.score,
            questionId: control.questionId,
          };
        });
        options.unshift({
          value: '',
          display: 'choose answer',
          score: 0,
          questionId: '',
        });

        return {
          tag: 'select-no-float',
          value: control.answerId[0],
          name: control.questionId,
          label: control.questionText,
          validator: 'required=true',
          options,
        };
      });

      controls.push({
        tag: 'hidden',
        value: json[0].questionaireId,
        name: 'questionaireId',
      });

      return controls;
    },
    {
      expiry: 10,
    }
  );

  return json;
}
